/**
 * Created by CH-E01327 on 09-03-2017.
 */
import { Injectable } from "@angular/core";
import { HttpClientService } from "../../common/http-client.service";
import { CommonService } from "../../common/common.service";
import { Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import swal from "sweetalert2";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class LoginService {
  EPB: string = "";
  userName: string = "";
  private msisdn: string;
  private otp: string;
  constructor(
    private commonService: CommonService,
    private http: HttpClientService,
    private router: Router
  ) {}

  setMsisdn(msisdn: string) {
    this.msisdn = msisdn;
  }

  // Method to get msisdn
  getMsisdn() {
    return this.msisdn;
  }
  setotp(otp: string) {
    this.otp = otp;
  }

  // Method to get msisdn
  getotp() {
    return this.otp;
  }

  login(data): any {
    return this.http.post("loginDetails", data, 2);
  }

  loginUser(logindata, header): Observable<any> {
    // return this.http.post("authentication/validate", logindata, 0, header);
    return this.http.get("api/v1/user/login/password", null, 25, header);
  }
  tokenData = {
    mfsCommonServiceRequest: {
      mfsAssistedTransaction: {
        accessCode: null,
        assistedEntityId: null,
        assistedMode: null,
      },
      mfsSourceInfo: {
        channelId: "22",
        surroundSystem: "3",
      },
      mfsTransactionInfo: {
        clientTransactionId: this.commonService.getRequestId(),
        requestId: this.commonService.getRequestId(),
        serviceType: "0",
        timestamp: Date.now(),
      },
    },
    mfsOptionalInfo: {
      info: [
        {
          key: "string",
          value: "string",
        },
      ],
    },
    mfsRequestInfo: {
      amount: null,
      charges: null,
      currency: null,
      entityId: null,
      expiryDate: null,
      fees: null,
      msisdn: null,
      email: null,
      remark: null,
      transactionInfo: null,
      walletType: null,
      notificationFlag: null,
    },
  };

  getMisidn(userName, head, callback, errorCallback) {
    this.http
      .get(
        "adminController/validateAdminUser/" +
          userName +
          "/null?channelId=22&surroundSystem=3",
        null,
        6
      )
      .subscribe(
        (data) => {
          if (data["status"] === "Failure" || data["status"] === "failure") {
            const errorMessage =
              data["message"] || "An error occurred. Please try again.";
            errorCallback(errorMessage);
            return;
          }

          if (data["status"] === "success" && data["object"]) {
            const otp = data["object"]["otp"];
            const msisdn = data["msdin"];

            // Store msisdn in the service
            this.setMsisdn(msisdn);
            this.setotp(otp);

            callback(data);
          } else {
            errorCallback("OTP has been sent on your registered email ID.");
          }
        },
        (error) => {
          let errorMessage = null;
          if (error && error._body) {
            try {
              const parsedError =
                typeof error._body === "string"
                  ? JSON.parse(error._body)
                  : error._body;
              if (parsedError && parsedError.message) {
                errorMessage = parsedError.message;
              }
            } catch (e) {
              // If parsing fails, continue
            }
          }
          errorCallback(errorMessage);
        }
      );
  }

  getOtp(data, callback, errorCallback) {
    this.commonService.token = "bearer " + data["token"];
    this.tokenData.mfsRequestInfo.msisdn = data["msisdn"];
    this.tokenData.mfsRequestInfo.email = data["email"];
    this.tokenData.mfsRequestInfo.notificationFlag = "3";
    this.validate.mfsRequestInfo.entityId = data["msisdn"];
    this.http.post("tokenManagement/get", this.tokenData, 6).subscribe(
      (data) => {
        if (
          data["mfsCommonServiceResponse"]["mfsStatusInfo"]["errorCode"] ==
          "100"
        ) {
          callback(data);
        } else {
          errorCallback(
            data["mfsCommonServiceResponse"]["mfsStatusInfo"][
              "errorDescription"
            ]
          );
        }
      },
      () => {
        errorCallback("User not exists");
      }
    );
  }

  validate = {
    mfsCommonServiceRequest: {
      mfsAssistedTransaction: {
        accessCode: null,
        assistedEntityId: null,
        assistedMode: null,
      },
      mfsSourceInfo: {
        channelId: "22",
        entityId: null,
        entityType: "",
        mpin: null,
        msisdn: null,
        surroundSystem: "3",
      },
      mfsTransactionInfo: {
        clientTransactionId: this.commonService.getRequestId(),
        requestId: this.commonService.getRequestId(),
        serviceType: "0",
        timestamp: Date.now(),
      },
    },
    mfsOptionalInfo: {
      info: [
        {
          key: "string",
          value: "string",
        },
      ],
    },
    mfsRequestInfo: {
      entityId: null,
      token: null,
    },
  };

  validateOtp(callback, errorCallback) {
    const params = {
      channelId: "22",
      surroundSystem: "3",
      otpType: "1013",
      otp: this.getotp(),
      msisdn: this.getMsisdn(), // Retrieve msisdn from the service
    };

    this.http.get("adminController/validateOtp", params, 6).subscribe(
      (data) => {
        if (data["status"] === "success") {
          callback(data);
        } else {
          errorCallback("Invalid Otp");
        }
      },
      () => {
        errorCallback();
      }
    );
  }

  errorMessage() {
    swal(
      "Error!",
      "Oops ! Something went wrong. Please try again after 5 minutes.",
      "info"
    ).then(
      () => {},
      () => {}
    );
  }

  changePasswordActivation(data, role, header) {
    //localStorage.clear();

    this.http.post("adminController/activateUser", data, 7, header).subscribe(
      (data) => {
        if (data["status"] === "success") {
          //this.successPopup("Password changed successfully");
          swal({
            title: "Success",
            text: "Password changed successfully",
            type: "success",
            confirmButtonText: "Ok",
          }).then(
            () => {
              if (role >= 6) {
                this.router.navigate(["/auth/login"]);
                // window.location.href=environment.CRM_ENDPOINT;
              } else {
                this.router.navigate(["/auth/login"]);
              }
            },
            () => {}
          );
        } else this.errorPopup("Unable to update password");
      },
      () => {
        this.errorPopup();
      }
    );
  }

  errorPopup(message?) {
    swal(
      "Error!",
      message ||
        "Oops ! Something went wrong. Please try again after 5 minutes.",
      "info"
    ).then(
      () => {},
      () => {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/auth/login/login.service.ts